"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var base_field_config_model_1 = require("./base-field-config.model");
var TripDatesFieldConfig = (function (_super) {
    __extends(TripDatesFieldConfig, _super);
    function TripDatesFieldConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TripDatesFieldConfig;
}(base_field_config_model_1.BaseFieldConfig));
exports.TripDatesFieldConfig = TripDatesFieldConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/trip-dates-config.model.js